import React from "react";
import { Overlay, Popover } from "react-bootstrap";

type Props = { show: boolean; targetRef: any };

const PasswordHintOverlay: React.FC<Props> = (props: Props) => {
	const { show, targetRef } = props;

	return (
		<>
			<Overlay container={targetRef} show={show} placement="top-start" target={targetRef?.current}>
				<Popover id="password-hint" className="field-hint">
					<Popover.Header className="h3 fw-bold mb-4 p-0">Password must</Popover.Header>
					<Popover.Body>
						<ul>
							<li>Have one number</li>
							<li>Have one uppercase character</li>
							<li>Have one lowercase character</li>
							<li>Have one special character</li>
							<li>Have 8 characters minimum</li>
						</ul>
					</Popover.Body>
				</Popover>
			</Overlay>
		</>
	);
};

export default PasswordHintOverlay;
